import { differenceInHours } from "date-fns";
import { getImageUrl } from "./file";

export const deleteImagesFromCache = (ids: number[]) => {
  caches
    .open("images")
    .then(cache => {
      ids.forEach(id => {
        cache.delete(getImageUrl(id)).catch(() => {});
      });
    })
    .catch(() => {});
};

export const clearStaleImagesFromCache = async () => {
  try {
    const imageCache = await caches.open("images");
    const requests = await imageCache.keys();

    requests.forEach(request =>
      imageCache
        .match(request)
        .then(response => {
          if (!response) {
            return;
          }

          const dateCached = response.headers.get("date");
          if (
            !dateCached ||
            differenceInHours(new Date(), new Date(dateCached)) > 48
          ) {
            imageCache.delete(request).catch(() => {});
          }
        })
        .catch(() => {})
    );
  } catch (error) {}
};
